// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1p_mA","colBig":"styles_colBig__3Uqwg","colSmall":"styles_colSmall__37zaF","shopifyNameWrapper":"styles_shopifyNameWrapper___kI_S"};